import { pageDto } from "../pagedto";
import { VatPatternDto } from './vatpatterndto';

export class VatPatternResponse {

    listVatPatternDto: VatPatternDto[] = [];

    pageDto: pageDto = new pageDto({});

}